import { RecommendationResponse } from '../../types/common';

class ErrorHandler {
  public getDefaultErrorResponse(): RecommendationResponse {
    return {
      products: [],
      algorithm: '',
      recommendationType: '',
      totalCount: 0,
      actualCount: 0,
      personalised: false,
    };
  }
}

const RecommendationErrorHandler = new ErrorHandler();

export default RecommendationErrorHandler;
